var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { createClient } from "@hey-api/client-fetch";
const _ApiService = class _ApiService {
  constructor() {
    __publicField(this, "_client", createClient({}));
    if (_ApiService.instance) {
      return _ApiService.instance;
    }
    _ApiService.instance = this;
  }
  static getInstance() {
    if (!_ApiService.instance) {
      _ApiService.instance = new _ApiService();
    }
    return _ApiService.instance;
  }
  get client() {
    return this._client;
  }
  updateConfig(config) {
    this._client = createClient({
      ...this.client.getConfig(),
      ...config
    });
  }
};
__publicField(_ApiService, "instance");
let ApiService = _ApiService;
export {
  ApiService as default
};
